export default "__VITE_ASSET__DEgzgZbS__"